import { useTasksDashboardContext } from '../context/TasksDashboardContext';
import useTasksDashboardColumns from './useTasksDashboardColumns';

export const useTasksDashboard = () => {
  const {
    aggregations,
    selectedTemplates,
    schedulesById,
    showEventTypeDrawer,
    mainLoading,
    mainError,
    mainLoaded,
    groupBy,
    openTimelineEvents,
    intl,
    setShowEventTypeDrawer,
    onBackFromTimeline,
    tableDataByDay,
    drawerState,
    toggleDrawer,
    selectedUsers,
    filters,
    setFilters,
    initialFilters,
    chartFilters,
    draftChartFilters,
    hasPendingFilters,
    applyFilters,
    fetch,
    queryDivisionIds,
    orgId,
    timeZone,
    disabledDate,
    setSelectedTemplates,
    toggle,
    isOpen,
  } = useTasksDashboardContext();

  const columns = useTasksDashboardColumns();

  return {
    aggregations,
    selectedTemplates,
    schedulesById,
    showEventTypeDrawer,
    mainLoading,
    mainError,
    mainLoaded,
    groupBy,
    openTimelineEvents,
    intl,
    setShowEventTypeDrawer,
    onBackFromTimeline,
    tableDataByDay,
    drawerState,
    toggleDrawer,
    selectedUsers,
    filters,
    setFilters,
    initialFilters,
    chartFilters,
    draftChartFilters,
    hasPendingFilters,
    applyFilters,
    fetch,
    queryDivisionIds,
    orgId,
    timeZone,
    disabledDate,
    setSelectedTemplates,
    toggle,
    isOpen,
    columns,
  };
};
